module.exports = {
    bindings: {
        result: '<'
    },
    templateUrl: 'good/components/customs-value-check-result.html'
};